import { UnreachableCaseError } from '@errors/unreachable';
import type {
  AutoConfiguratorState,
  Field,
  FieldId,
  LineItemFieldKey,
  QuantityBreakFieldKey,
} from '@snap-types/models/auto-configurator/state';

export function getField(
  state: AutoConfiguratorState,
  fieldId: FieldId,
): Field {
  const model = fieldId.model;

  switch (model) {
    case 'lineItem':
      return getLineItemField(state, fieldId.key);

    case 'quantityBreak':
      return getQuantityBreakField(state, fieldId.key);

    /* v8 ignore next 2 */
    default:
      throw new UnreachableCaseError(model);
  }
}

function getLineItemField(
  state: AutoConfiguratorState,
  key: LineItemFieldKey,
): Field {
  const field = state.fields.lineItem[key];

  if (!field) {
    throw new Error(`No line item field found for key: "${key}"`);
  }

  return field;
}

function getQuantityBreakField(
  state: AutoConfiguratorState,
  key: QuantityBreakFieldKey,
): Field {
  const field = state.fields.quantityBreak[key];

  if (!field) {
    throw new Error(`No quantity break field found for key: "${key}"`);
  }

  return field;
}
